import { getPreviousActionId } from 'automation-ui-action-features/records/recordsUtils';
/**
 * Determines if the given edge ID represents the first edge for an action
 * @param edgeId - The ID of the edge to check
 * @returns boolean indicating if this is the first edge for an action
 */
export const isAllowedRecommendationEdgeForBranchAction = edgeId => {
  return edgeId.endsWith('-2');
};
export const isEdgeOfBranchAction = (flow, edgeId) => {
  var _action$isBranch;
  const actionId = getPreviousActionId(edgeId);
  const action = flow.getActionById(actionId);
  return (_action$isBranch = action === null || action === void 0 ? void 0 : action.isBranch()) !== null && _action$isBranch !== void 0 ? _action$isBranch : false;
};